import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Task\GetUsersListByFuneralHomeController::__invoke
* @see app/Http/Controllers/Task/GetUsersListByFuneralHomeController.php
* @route '/api/task/fetch-users/{funeralHome_id}'
*/
const GetUsersListByFuneralHomeController = (args: { funeralHome_id: string | number } | [funeralHome_id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetUsersListByFuneralHomeController.url(args, options),
    method: 'get',
})

GetUsersListByFuneralHomeController.definition = {
    methods: ["get","head"],
    url: '/api/task/fetch-users/{funeralHome_id}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Task\GetUsersListByFuneralHomeController::__invoke
* @see app/Http/Controllers/Task/GetUsersListByFuneralHomeController.php
* @route '/api/task/fetch-users/{funeralHome_id}'
*/
GetUsersListByFuneralHomeController.url = (args: { funeralHome_id: string | number } | [funeralHome_id: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { funeralHome_id: args }
    }

    if (Array.isArray(args)) {
        args = {
            funeralHome_id: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        funeralHome_id: args.funeralHome_id,
    }

    return GetUsersListByFuneralHomeController.definition.url
            .replace('{funeralHome_id}', parsedArgs.funeralHome_id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Task\GetUsersListByFuneralHomeController::__invoke
* @see app/Http/Controllers/Task/GetUsersListByFuneralHomeController.php
* @route '/api/task/fetch-users/{funeralHome_id}'
*/
GetUsersListByFuneralHomeController.get = (args: { funeralHome_id: string | number } | [funeralHome_id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetUsersListByFuneralHomeController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Task\GetUsersListByFuneralHomeController::__invoke
* @see app/Http/Controllers/Task/GetUsersListByFuneralHomeController.php
* @route '/api/task/fetch-users/{funeralHome_id}'
*/
GetUsersListByFuneralHomeController.head = (args: { funeralHome_id: string | number } | [funeralHome_id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetUsersListByFuneralHomeController.url(args, options),
    method: 'head',
})

export default GetUsersListByFuneralHomeController